import React, { useEffect, useState } from "react";
import AddBtn from "../../Assets/addIcon.png";
import RemoveBtn from "../../Assets/removeIcon.png";
import { useDispatch, useSelector } from "react-redux";
import { addItem, addNote } from "../../redux/action";

const Note = ({ id, cartKey, tab, title, note }) => {
  const dispatch = useDispatch();
  const cart = useSelector((state) => state?.user.cart);
  const targetKey = cartKey || id;
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [noteText, setNoteText] = useState(cart[id]?.note || "");

  useEffect(() => {
    if (note !== undefined && note !== null) {
      setNoteText(note);
    } else if (cart[targetKey]?.note) {
      setNoteText(cart[targetKey]?.note);
    }
  }, [note, cart, targetKey]);

  const handleSaveNote = () => {
    dispatch(
      addNote({
        id: id,
        cartKey: targetKey,
        note: noteText,
      }),
    );
    setIsPopupOpen(false);
  };

  const togglePopup = (e) => {
    e.stopPropagation(); // Prevents navigating to detail page
    setNoteText(cart[targetKey]?.note || note || "");
    setIsPopupOpen(!isPopupOpen);
  };

  // const handleIncrement = () => {
  //     dispatch(addItem({ id: id, selectedTab: tab }));
  // };

  // const handleDecrement = () => {
  //     dispatch(addNote({ id: id, selectedTab: tab }));
  // };

  return (
    <>
      <button type="button" className="addNoteLabel" onClick={togglePopup}>
        <span>👨‍🍳 Add Note to Chef</span>
      </button>

      {/* --- NOTE POPUP MODAL --- */}
      {isPopupOpen && (
        <div className="noteModalOverlay" onClick={togglePopup}>
          <div
            className="noteModalContent"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Add Note for {title}</h3>
            <textarea
              className="noteTextArea"
              placeholder="Example: Make it extra spicy / No onions"
              value={noteText}
              onChange={(e) => setNoteText(e.target.value)}
              autoFocus
            />
            <div className="noteModalButtons">
              <button type="button" className="cancelNoteBtn" onClick={togglePopup}>
                Cancel
              </button>
              <button type="button" className="saveNoteBtn btn" onClick={handleSaveNote}>
                Save Note
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Note;
